<template>
    
    <header style=" margin-top: -20px; margin-bottom: 25px; padding-left: 0; padding-right: 0;" id="headerBox">
                <div class="row w-100 m-0 dd-none blkk" style="padding: 0;  width: 100%; padding-left: 20px; padding-right: 20px;" >
                    <div class="col px-0">
                        <div class="row w-100 align-items-center justify-content-between position-relative">
                            <div class="col w-auto hp-flex-none hp-mobile-sidebar-button me-24 px-0" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu" aria-controls="mobileMenu">
                                <button type="button" class="btn btn-text btn-icon-only">
                                    <!-- <i class="ri-2x ri-menu-2-line hp-text-color-black-80 hp-text-color-dark-30 lh-1" ></i> -->
                                    <i class="hp-text-color-dark-0 ri-2x ri-menu-2-line" style="font-size: 22px;"></i>
                                </button>
                                
                            </div>

                            <div class="col w-auto hp-flex-none hp-mobile-sidebar-button me-24 px-0" >
                                
                                <img src="@/assets/img/favicon.png" alt="" style="width: 26px; margin-top: 20px;" id="mobileLogo">
                                <h2 style="text-align: center; font-size: 18px; margin-top: 20px;" id="mobileTitle"></h2>
                                
                            </div>

                            <!-- ANNOUNCEMENT -->
                            <!-- <div class="hp-header-text-info col col-lg-14 col-xl-16 hp-header-start-text d-flex align-items-center hp-horizontal-none">
                                <div class="d-flex overflow-hidden rounded-4 hp-bg-color-black-0 hp-bg-color-dark-100" style="min-width: 45px; width: 45px; height: 45px;">
                                    <img src="@/assets/img/newspaper.svg" alt="Newspaper" height="80%" style="margin-top: auto; margin-left: auto;">
                                </div>

                                <p class="hp-header-start-text-item hp-input-label fw-normal hp-text-color-black-100 hp-text-color-dark-0 ms-12 mb-0 lh-1 d-flex align-items-center">
                                    Do you know the latest update of 2022?&nbsp;&nbsp;
                                    <span class="hp-text-color-primary-1">Our roadmap is alive for future updates.</span>
                                </p>
                            </div> -->

                            <div class="col hp-flex-none w-auto pe-0">
                                <div class="row align-items-center justify-content-center" data-bs-toggle="modal" data-bs-target="#settings">
                                    

                                    <div class="hover-dropdown-fade w-auto px-0 d-flex align-items-center position-relative">
                                        <!-- <button type="button" class="btn btn-icon-only bg-transparen border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition d-flex align-items-center justify-content-center">
                                            <i class="hp-text-color-dark-0 ri-2x ri-settings-3-line" style="font-size: 24px;"></i>
                                            
                                        </button> -->

                                        <button type="button" class="btn btn-text btn-icon-only" >
                                            <i class="hp-text-color-dark-0 ri-2x ri-settings-3-line" style="font-size: 22px;"></i>
                                            
                                        </button>

                                        

                                        
                                    </div>

                                    

                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    </header>

    

</template>

<style>
    .blkk{
        background-color: #fff;
    }

    body.dark .blkk{
        background-color: #141414;
    }
</style>

<script>

    export default {

    }

    

</script>